<template>
    <div class="container type3" @click="$event.stopPropagation();">
        <div class="month">
            <a href="javascript:void(0)" @click="showPrevMonth" style="width:27px; height:40px; display:grid; place-items: center;"><img :src="require('@/assets/img/calendar_next_btn.png')" style="transform: rotate(180deg);"></a>
            <span style="font-size:20px; color:#231815;">{{year.substr(2, 2)}}년 {{month}}월</span>
            <a href="javascript:void(0)" @click="showNextMonth" style="width:27px;height:40px; display:grid; place-items: center;"><img :src="require('@/assets/img/calendar_next_btn.png')"></a>
        </div>
        <div style="height:30px;"></div>
        <div class="date" >
            <ul class="calendar_header">
                <li style="color:#E60012 !important;">일</li>
                <li>월</li>
                <li>화</li>
                <li>수</li>
                <li>목</li>
                <li>금</li>
                <li>토</li>
            </ul>
            <div class="calendar_wrap" style="">
                <div class="calendar_location" :style="{top: '-' + (selectedWeekIndex * eachWeekHeight) + 'px'}">
                    <ul v-for="week, i in monthData" :key="i">
                        <li :class="[selectedRowIndex == i && selectedColIndex == j ? 'active' : '', day.hasOwnProperty('active') && day.active === false ? 'inactive' : '', mode === 'delayrequest' && parameters != null && parameters.hasOwnProperty(day.key) ? 'inactive' : '']"
                            :style="{backgroundColor : getColorBromBtnState(additionalInfo, day.key)}"
                            v-for="day, j in week" :key="i + '' + j"
                            @click="selectDate(i, j)"
                        >
                            <!--<div class="calendar_today_mark" v-if="day.key == todayStr"></div>-->
                            <span class="calendar_date_text">{{day.date == 0 ? '' : day.date}}</span>
                            <div class="" style="text-align:center; height:36px; margin-top:5px; font-weight:500; line-height:16px;" v-html="getStringFromBtnState(additionalInfo, day.key)"></div>
                            <div class="calendar_additional_info_wrap" v-if="additionalInfo.hasOwnProperty(day.key)">
                                <!--<div class="calendar_additional_info_round expired" v-if="additionalInfo[day.key].hasOwnProperty('expired')"></div>-->
                                <!--<div class="calendar_additional_info_round available" ></div>-->
                                <!--<div class="calendar_additional_info_round available" v-if="additionalInfo[day.key].hasOwnProperty('complete')"></div>-->
                                <!--<div class="calendar_additional_info_round others" v-if="additionalInfo[day.key].hasOwnProperty('others')"></div>-->
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import calendar from '@/modules/calendar';
    //const cal = new calendar();

    export default {
        name: "calendar",
        props:['selectDateCallback', 'startDate', 'monthChangeHandler', 'detectMonthChangeCall', 'isToggleHidden', 'isFirstShowMonth', 'activeStartDate', 'activeEndDate', 'mode', 'parameters'],
        data(){
            return {
                monthData : [],
                year : '',
                month : '',
                eachWeekHeight : 70,
                showAll : false,
                selectedWeekIndex : 0,
                curHeight : this.eachWeekHeight,
                selectedRowIndex : -1,
                selectedColIndex : -1,
                additionalInfo : {},
                lastSelectedYear : '',
                lastSelectedMonth : '',
                lastSelectedRowIndex : -1,
                lastSelectedColIndex : -1,
                todayStr : '',
                execCnt : 0,
                cal : null,
            }
        },
        watch : {
            detectMonthChangeCall(){
                this.handleMonthChange();
            }
        },
        methods : {
            getStringFromBtnState(additional_info, key){
                let btn_state = this.$hasOwnProperty(additional_info, key) ? additional_info[key].btn_state : '';
                if(!btn_state) return '';
                let btn_name = '';
                switch(btn_state){
                    case 'available':
                        btn_name = '예약<br>가능';
                        break;
                    case 'applied':
                        btn_name = '예약<br>신청';
                        break;
                    case 'confirmed':
                        btn_name = '예약<br>확정';
                        break;
                    case 'attended':
                        btn_name = '근무<br>중';
                        break;
                    case 'completed':
                        btn_name = '근무<br>완료';
                        break;
                    case 'absent':
                        btn_name = '근무<br>불참';
                        break;
                }

                return btn_name;
            },
            getColorBromBtnState(additional_info, key){
                let btn_state = this.$hasOwnProperty(additional_info, key) ? additional_info[key].btn_state : '';
                if(!btn_state) return '';
                let backgroundColor = '';
                switch(btn_state){
                    case 'available':
                        backgroundColor = '#A9D49C';
                        break;
                    case 'applied':
                        backgroundColor = '#94CBEF';
                        break;
                    case 'confirmed':
                        backgroundColor = '#F9C156';
                        break;
                    case 'attended':
                        backgroundColor = '#FFF16A';
                        break;
                    case 'completed':
                        backgroundColor = '#E2E1E0';
                        break;
                    case 'absent':
                        backgroundColor = '#ED724A';
                        break;
                }

                return backgroundColor;
            },
            getMonthData(){
                this.monthData = this.cal.getMonthData();
                this.year = this.cal.getYear();
                this.month = parseInt(this.cal.getMonth());
            },
            showPrevMonth(){
                this.showAll = true;
                this.cal.setPrevMonth();
                this.handleMonthChange();
            },
            showNextMonth(){
                this.showAll = true;
                this.cal.setNextMonth();
                this.handleMonthChange();
            },
            handleMonthChange(){
                this.getMonthData();
                if(this.monthChangeHandler != null){
                    this.monthChangeHandler((additionalInfo) => {
                        this.additionalInfo = additionalInfo;
                        this.getMonthData();
                    }, this.cal.getYear(), this.cal.getMonth());
                }
            },
            selectDate(i, j){
                this.selectedRowIndex = i;
                this.selectedColIndex = j;
                this.lastSelectedRowIndex = i;
                this.lastSelectedColIndex = j;
                this.lastSelectedYear = this.year;
                this.lastSelectedMonth = this.month;

                this.selectDateCallback(this.$hasOwnProperty(this.additionalInfo, this.monthData[i][j].key) ? this.additionalInfo[this.monthData[i][j].key] : null);

                // if((this.$hasOwnProperty(this.monthData[i][j], 'active') && this.monthData[i][j].active === false) || (this.parameters != null && this.$hasOwnProperty(this.parameters, this.monthData[i][j].key))){
                //     this.selectDateCallback('');
                // }else {
                //     this.selectDateCallback(this.cal.getDateStrBy(i,j));
                //     // this.closeCalendar();
                // }
            },
        },
        mounted(){
            this.cal.init(this.startDate, this.activeStartDate, this.activeEndDate, false);
            //cal.setChangeMonthHandler(this.monthChangeHandler);
            this.handleMonthChange();
        },
        created (){
            this.cal = new calendar();
            this.todayStr = moment().format('YYYY-MM-DD');

            if(this.isFirstShowMonth != null && this.isFirstShowMonth){
                this.showAll = true;
                this.execCnt = 1;
            }
        }
    }
</script>

<style scoped>
    *{margin: 0;padding: 0;}
    ul, ol {
        list-style: none;
    }
    .container.type3 {
        width: 100%;
        padding: 15px;
        box-sizing: border-box;
    }

    .month {
        margin: 0px auto;
        overflow: hidden;
        line-height: 1;
        text-align: center;
        display: flex;
        justify-content: center;
    }

    .month img {
        width: 100%;
        height: auto;
    }

    .month a {
        width: 7px;
        display: inline-block;
        padding: 11px 10px;
        vertical-align: top;
    }

    .month span {
        text-align: center;
        color: #999;
        font-size: 15px;
        font-weight: bold;
        display: inline-block;
        padding: 10px 0px;
        width: 95px;
    }

    .date ul {
        width: 100%;
        overflow: hidden;
        display: table;
    }

    ul.calendar_header{
        border-top-left-radius:8px;
        border-top-right-radius:8px;
        background-color: var(--color-main);
    }

    ul.calendar_header > li{
        font-size:12px;
        padding:10px 0px;
        color:white !important;
        text-align:center;
    }

    .date>ul:first-child li {
        color: #333;
        font-weight: bold;
    }

    .date li {
        font-size: 16px;
        display: table-cell;
        width: 14.28%;
        padding: 5px 5px;
        box-sizing: border-box;
        text-align: left;
        position:relative;
        cursor:pointer;
        border-left:1px solid var(--color-main);
        color:#050000;
        height:68px;
        vertical-align: top;
    }

    .calendar_header li {height:32px;}

    .date li.active {
        /*background: #eaf5fd;*/
        /*color: #000;*/
        /*border-radius: 3px;*/
    }

    .date>ul:first-child li.active {
        background: none;
    }

    .date ul li:first-child {
        color: #E60012;
    }

    .date ul li:last-child {
        border-right:1px solid var(--color-main);
        /*color: #4c84ff;*/
    }

    .date .hide {
        display: none;
    }

    .date .toggle {
        width: 100%;
        display: block;
        border-radius: 3px;
        border: 1px solid #ddd;
        text-align: center;
        text-indent: -9999px;
        padding: 10px 0;
        overflow: hidden;

    }


    .calendar_location > ul {
        border-bottom:1px solid var(--color-main)
    }

    .calendar_toggle{
        /*background: url(../images/more2.png) no-repeat center/19px auto;*/
        transition:transform 0.3s ease-in;
    }

    .calendar_toggle.active{
        transform:rotate(180deg);
    }

    .date .toggle.active {
        /*background: url(../images/return.png) no-repeat center/19px auto;*/
    }

    .calendar_wrap{
        position: relative;
        transition: height .3s ease;
    }
    .calendar_location{width: 100%; transition: top .3s ease;}
    .calendar_additional_info_wrap{position:absolute; bottom:3px; left:50%;transform: translateX(-50%); display:flex;}
    .calendar_additional_info_round{width:6px; height:6px;border-radius:3px; display:inline-block;background-color: #c1e3fc; margin:0px 1px;}
    .calendar_additional_info_round + .calendar_additional_info_round{margin-left:3px;}
    .expired{background-color:red;}
    .available{background-color:#4c84ff;}
    .complete{background-color: #1ab394;}
    .complete2{background-color: #c1e3fc;}
    .others{background-color: #7587ad;}
    .calendar_today_mark{ background-color: #aac7ef;position: absolute;left: 50%;top:50%; transform:translate(-50%, -50%);width:24px;height:24px;border-radius: 50%;}
    .calendar_date_text{position:relative; font-size:15px; font-weight:bold; }
    .inactive{background-color:#f4f4f4}
</style>